import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import SmallFooter from '../../components/SmallFooter'
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from "../../assets/logo.png"


const Checkout = () => {
    const [standardDeliveryMethod, setStandardDeliveryMethod] = React.useState(true)

    const [deliveryCost, setDeliveryCost] = React.useState(0)
    const [products, setProducts] = React.useState([])
    const [price, setPrice] = React.useState(0)
    const [discount, setDiscount] = React.useState(0)
    const [total, setTotal] = React.useState(0)

    const [email, setEmail] = React.useState('')
    const [firstName, setFirstName] = React.useState('')
    const [lastName, setLastName] = React.useState('')
    const [address, setAddress] = React.useState('')
    const [landmark, setLandmark] = React.useState('')
    const [city, setCity] = React.useState('')
    const [state, setState] = React.useState('')
    const [zip, setZip] = React.useState('')
    const [country, setCountry] = React.useState('')
    const [phone, setPhone] = React.useState('')

    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });


    const calaculateTotal = (data) => {
        let total = 0;
        data.forEach((item) => {
            total += item.price
        })
        setPrice(total)

        let discount = 0;
        data.forEach((item) => {
            discount += item.discount
        })
        setDiscount(discount)
    }

    useEffect(() => {
        setTotal(price + deliveryCost - discount)
    }, [price, deliveryCost, discount])

    useEffect(() => {
        if (standardDeliveryMethod) {
            setDeliveryCost(50)
        } else {
            setDeliveryCost(100)
        }
    }, [standardDeliveryMethod])


    const removeItem = (id) => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/cart/deleteAllItem', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    productId: id
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.success) {
                        setProducts(data.cart)
                        calaculateTotal(data.cart)
                    }
                }
                )
        } catch (error) {
            console.log(error)
        }
    }

    const validate = () => {
        if (email === '' || firstName === '' || lastName === '' || address === '' || city === '' || state === '' || zip === '' || country === '' || phone === '') {
            notify('Please fill all the fields')
            return false
        }
        if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/)) {
            notify('Please enter a valid email')
            return false
        }
        if (!firstName.match(/^[a-zA-Z ]+$/)) {
            notify('First Name must contain only letters')
            return false
        }
        if (!lastName.match(/^[a-zA-Z ]+$/)) {
            notify('Last Name must contain only letters')
            return false
        }
        if (!city.match(/^[a-zA-Z ]+$/)) {
            notify('City must contain only letters')
            return false
        }
        if (!state.match(/^[a-zA-Z ]+$/)) {
            notify('State must contain only letters')
            return false
        }
        if (!zip.match(/^[1-9][0-9]{5}$/)) {
            notify('Please enter a valid pin code')
            return false
        }
        if (!country.match(/^[a-zA-Z ]+$/)) {
            notify('Country must contain only letters')
            return false
        }
        if (!phone.match(/^[6-9]\d{9}$/)) {
            notify('Please enter a valid phone number')
            return false
        }
        return true
    }

    const loadScript = (src) => {
        return new Promise((resovle) => {
            const script = document.createElement("script");
            script.src = src;

            script.onload = () => {
                resovle(true);
            };

            script.onerror = () => {
                resovle(false);
            };

            document.body.appendChild(script);
        });
    }

    const displayRazorpay = async (data) => {
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            alert("You are offline... Failed to load Razorpay SDK");
            return;
        }

        const options = {
            key: 'rzp_test_xf7vrKf9Z9Dp92',
            order_id: data.paymentDetails.id,
            currency: data.paymentDetails.currency,
            amount: data.paymentDetails.amount,
            name: "Go Green",
            description: "Thanks for purchasing",
            image: logo,


            handler: function (response) {

                try {
                    fetch(process.env.REACT_APP_SERVER_URL + '/checkout/verify', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('token')}`
                        },
                        body: JSON.stringify({
                            razorpayResponse: response,
                            oldData: data,
                            userData: {
                                email,
                                firstName,
                                lastName,
                                address,
                                landmark,
                                city,
                                state,
                                zip,
                                country,
                                phone,
                                paymentMethod: 'Razorpay'
                            }
                        })
                    })
                        .then(res => res.json())
                        .then(data => {
                            console.log(data)
                            if (data.success) {
                                window.location.href = `/invoice/${data.orderId}`
                            }
                            else {
                                notify('Payment Failed')
                            }

                        }
                        )
                        .catch(err => {
                            notify(err.message)
                        }
                        )
                } catch (error) {
                    console.log(error)
                    notify(error.message)
                }
            },
            prefill: {
                name: "Go Greeen",
            },
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    }



    const handlePayment = (e) => {
        e.preventDefault()
        if (validate())
            try {
                fetch(process.env.REACT_APP_SERVER_URL + '/checkout/createOrder', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({
                        standardDeliveryMethod
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data)
                        if (data.success) {
                            notify(data.message)
                            displayRazorpay(data)
                        }
                        else {
                            notify(data.message)
                        }
                    }
                    )
                    .catch(err => {
                        notify(err.message)
                    }
                    )
            } catch (error) {
                console.log(error)
                notify(error.message)
            }
    }

    useEffect(() => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/cart/getcart', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },

            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.success) {
                        setProducts(data.cart)
                        calaculateTotal(data.cart)
                        if (data.cart.length === 0) {
                            window.location.href = '/'
                        }
                    }
                }
                )
        } catch (error) {
            console.log(error)
        }
    }, [])

    return (
        <div className='relative dark:bg-black dark:text-white bg-[#F8FBF8] font-poppins overflow-x-hidden'>
            <Navbar />
            <div>
                <ToastContainer className='mt-20' />
            </div>
            <div className='flex  lg:mx-0 flex-col lg:flex-row justify-between lg:px-32 my-20 w-full '>
                <div className='mx-2 lg:w-1/2 lg:pr-10'>
                    <h1 className='text-2xl'>Contact Information</h1>
                    <div className='mt-5'>
                        <label htmlFor="email" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">Email Address</label>
                        <input data-testid="email" placeholder="Enter your email address" className="block w-full appearance-none rounded-md border dark:text-black border-gray-300 lg:px-3  placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" type="email" id="email" name="email" defaultValue="" onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="relative mt-10">
                        <div className="absolute inset-0 flex items-center" aria-hidden="true">
                            <div className="w-full border-t border-gray-300">
                            </div>
                        </div>
                    </div>
                    <div className='mt-20 w-full'>
                        <h1 className='text-2xl'>Shipping Information</h1>
                        <div className='flex w-full items-center justify-between'>
                            <div className='mt-5 w-1/2'>
                                <label htmlFor="fname" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">First Name</label>
                                <input placeholder="" className="block appearance-none rounded-md border border-gray-300 lg:px-3  placeholder-gray-400 dark:text-black shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm w-11/12" required="" type="text" id="fname" name="fname" defaultValue="" onChange={(e) => setFirstName(e.target.value)} />
                            </div>
                            <div className='mt-5 w-1/2'>
                                <label htmlFor="lname" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">Last Name</label>
                                <input placeholder="" className="block w-full appearance-none rounded-md border border-gray-300 lg:px-3  placeholder dark:text-black-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 dark:text-black disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" type="text" id="lname" name="lname" defaultValue="" onChange={(e) => setLastName(e.target.value)} />
                            </div>
                        </div>
                        <div className='mt-5 '>
                            <label htmlFor="address" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">Address</label>
                            <input placeholder="" className="block w-full appearance-none rounded-md border border-gray-300 px-3  placeholder-gray-400 dark:text-black shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" type="text" id="address" name="address" defaultValue="" onChange={(e) => setAddress(e.target.value)} />
                        </div>
                        <div className='mt-5 '>
                            <label htmlFor="landmark" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">Landmark</label>
                            <input placeholder="" className="block w-full appearance-none rounded-md border border-gray-300 px-3  placeholder-gray-400  dark:text-black shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" type="text" id="landmark" name="landmark" defaultValue="" onChange={(e) => setLandmark(e.target.value)} />
                        </div>
                        <div className='flex w-full items-center justify-between'>
                            <div className='mt-5 w-1/2'>
                                <label htmlFor="city" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">City</label>
                                <input placeholder="" className="block appearance-none rounded-md border border-gray-300 px-3  placeholder-gray-400  dark:text-black shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm w-11/12" required="" type="text" id="city" name="city" defaultValue="" onChange={(e) => setCity(e.target.value)} />
                            </div>
                            <div className='mt-5 w-1/2'>
                                <label htmlFor="state" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">State</label>
                                <input placeholder="" className="block w-full appearance-none rounded-md border border-gray-300 px-3  placeholder-gray-400 dark:text-black shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" type="text" id="state" name="state" defaultValue="" onChange={(e) => setState(e.target.value)} />
                            </div>
                        </div>
                        <div className='flex w-full items-center justify-between'>
                            <div className='mt-5 w-1/2'>
                                <label htmlFor="country" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">Country</label>
                                <input placeholder="" className="block appearance-none rounded-md border border-gray-300 px-3  placeholder-gray-400 shadow-sm dark:text-black focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm w-11/12" required="" type="text" id="country" name="country" defaultValue="" onChange={(e) => setCountry(e.target.value)} />
                            </div>
                            <div className='mt-5 w-1/2'>
                                <label htmlFor="postalcode" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">Postal Code</label>
                                <input placeholder="" className="block w-full appearance-none rounded-md border border-gray-300 px-3  placeholder-gray-400 shadow-sm focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 dark:text-black sm:text-sm" required="" type="text" id="postalcode" name="postalcode" defaultValue="" onChange={(e) => setZip(e.target.value)} />
                            </div>
                        </div>
                        <div className='mt-5'>
                            <label htmlFor="phone" className="mb-1 block text-sm font-medium dark:text-white text-gray-900">Phone</label>
                            <input data-testid="email" className="block w-full appearance-none rounded-md border border-gray-300 px-3  placeholder-gray-400 shadow-sm dark:text-black focus:border-green-500 focus:outline-none focus:ring-green-500 disabled:cursor-wait disabled:opacity-50 sm:text-sm" required="" type="text" id="phone" name="phone" defaultValue="" onChange={(e) => setPhone(e.target.value)} />
                        </div>
                    </div>
                    <div className="relative mt-10">
                        <div className="absolute inset-0 flex items-center" aria-hidden="true">
                            <div className="w-full border-t border-gray-300">
                            </div>
                        </div>
                    </div>
                    <div className='w-full mt-20'>
                        <h1 className='text-2xl'>Delivery Method</h1>
                        <div className='flex justify-center items-center w-full mt-5'>
                            <div onClick={() => setStandardDeliveryMethod(true)} className={`w-1/2 mr-10 h-28 rounded-2xl flex flex-col justify-between py-2 px-5 cursor-pointer ${standardDeliveryMethod ? 'border-2 border-green-600' : 'border-2 border-gray-300'}`}>
                                <div>
                                    <div><p>Standard</p></div>
                                    <div className='text-sm dark:text-gray-400 text-gray-600'><p>4-10 business days</p></div>
                                </div>
                                <div><p>Rs 50</p></div>
                            </div>
                            <div onClick={() => setStandardDeliveryMethod(false)} className={`w-1/2 mr-10 h-28 rounded-2xl flex flex-col justify-between py-2 px-5 cursor-pointer ${!standardDeliveryMethod ? 'border-2 border-green-600' : 'border-2 border-gray-300'}`}><div>
                                <div><p>Express</p></div>
                                <div className='text-sm text-gray-600 dark:text-gray-400'><p>2-5 business days</p></div>
                            </div>
                                <div><p>Rs 100</p></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mt-5 lg:mt-0 mx-2 lg:w-1/2'>
                    <h1 className='text-2xl'>Order Summary</h1>

                    <div className="flex flex-col overflow-hidden dark:bg-black dark:shadow-gray-600 bg-white shadow-xl mt-9 rounded-2xl">
                        <div className="flex-1 overflow-y-auto py-6 px-4 sm:px-6">
                            <div className="flex items-start justify-between">
                                <p className="text-lg font-medium dark:text-white text-gray-900">Shopping cart</p>
                            </div>

                            <div className="mt-8">
                                <div className="flow-root">
                                    <ul className="-my-6 divide-y divide-gray-200">
                                        {products.map((product) => (
                                            <li key={product.products} className="flex py-6">
                                                <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                                    <img
                                                        src={product.imgUrl}
                                                        alt='...'
                                                        className="h-full w-full object-cover object-center"
                                                    />
                                                </div>

                                                <div className="ml-4 flex flex-1 flex-col">
                                                    <div>
                                                        <div className="flex justify-between text-base font-medium dark:text-white text-gray-900">
                                                            <h3 className='w-56 truncate'>
                                                                <a target="_blank" href={`/dp/${product.products}`} rel="noreferrer">{product.name}</a>
                                                            </h3>
                                                            <div>
                                                                <p className="ml-4">Price: ₹ {product.price}</p>
                                                                <p className="ml-4">Discount: ₹ {Math.floor(product.discount)}</p>
                                                            </div>
                                                        </div>
                                                        <p className="mt-1 text-sm text-gray-500">{product.type}</p>
                                                    </div>
                                                    <div className="flex flex-1 items-end justify-between text-sm">
                                                        <p className="text-gray-500">Qty {product.quantity}</p>

                                                        <div className="flex">
                                                            <button
                                                                onClick={() => { removeItem(product.products) }}
                                                                type="button"
                                                                className="font-medium text-green-600 hover:text-green-500"
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                            <div className="flex justify-between text-sm dark:text-white text-gray-800">
                                <p>Total Discount</p>
                                <p>- ₹ {Math.floor(discount)}</p>
                            </div>
                            <div className="flex justify-between text-sm text-gray-800 dark:text-white">
                                <p>Delivery charges</p>
                                <p>₹ {deliveryCost}</p>
                            </div>
                            <div className="flex justify-between text-base mt-3 font-medium  dark:text-white text-gray-900">
                                <p>Subtotal</p>
                                <p>Rs {total}</p>
                            </div>

                            <div className="mt-6">
                                <Link
                                    to="/invoice"
                                    className="flex items-center justify-center rounded-md border border-transparent bg-green-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-green-700"
                                    onClick={(e) => handlePayment(e)}
                                >
                                    Confirm Order
                                </Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <SmallFooter />
        </div >
    )
}

export default Checkout